export const kn = { // 肯尼亚文案
    'imgUrl': '/country/kenya/luck-christmas',

    'drawsTitle': 'Chances Left:',

    'hasPrize': 'Congratulation',

    'noPrize': ' ',

    'inviteMsg': 'Invitation Code',

    'inviteCode': 'My invitation code',
    
    'copy': 'click on the copy',

    'title': 'Lucky Draws',

    'prizeRecords': 'Prize Record',

    'prizeRulesTitle': 'Rule Of Activity',

    'numNote': 'How to Get Lucky Draws?',

    'inviteBtnMsg': 'INVITE NOW',// INVITE NOW

    'modelContent': () => `
        <ol>
            <b><li>Apply & Repay a loan</li></b>
            <ul>
                <li>Apply a loan → get 1 draw</li>
                <li>Repay 1 or more days in advance → get 2 draws</li>
                <li>Repay on time  → get 1 draw</li>
            </ul>

            <b><li>Inviting Friends</li></b>
            <ul><li>friends filled in info → get 2 draws</li></ul>
        </ol>
    `,

    'noPrizeModelContent': (_class) => `
        <div className=${ _class }>
            <h2 style="text-align:center;font-size:0.5rem;color:#fff">Sorry</h2>
            <p class="no-prize-msg" style="text-align:center">No prize.</br>Better luck next time.</p>
        </div>
    `,

    'hasPrizeModelContent': (_class,awardId,HasLuckMsg,bgClass,prizeTypeMsg,award,activityEndDate,sign) => `
        <div className='${ _class }' id='l${ awardId }'>
            <p style="text-align:center;margin-top:0;word-break:break-word;">${ prizeTypeMsg }</p>
            <div className="name-img" style="
                background-image: url(${ bgClass });
                background-size:100% 100%;margin:0 auto;
            ">
                <div style="display:flex;">
                    <div style="width:1.5rem;margin-left:0;display:flex;justify-content: center;align-items: center;">
                        <p style="font-size:0.19rem;font-weight:normal;margin-top:0.369rem;margin-right:0rem;">${ sign }</p>
                        <p style="margin:0;font-size:0.4rem;">${ award.text }</p>
                    </div>
                    <div style="flex:1;display:flex;flex-direction:column;">
                        <p style="color:#0C0C0C;margin:0;font-size:0.2rem;line-height:0.25rem;padding-bottom:0.3rem;margin-top:0.26rem;font-weight:bold;word-wrap: break-word;">${ HasLuckMsg }</p>
                        <p style="color:#999999;margin:0;font-size:0.15rem;line-height:0;">Expire Time: ${ activityEndDate }</p>
                    </div>
                </div>
            </div>
        </div>
    `,

    'powerPrizeModelContent': (_class,awardId,powerAndCharge,prizeTypeMsg,w=2.8,h=1.15) => `
        <div className='${ _class }' id='l${ awardId }'>
            <p style="text-align:center;margin-top:0;word-break:break-word;">${ prizeTypeMsg }</p>
            <div className="name-img" style="
                width:${w}rem;
                height:${h}rem;
                background-image: url(${ powerAndCharge });
                background-size:100% 100%;margin:0 auto;
            ">
            </div>
        </div>
    `,

    'rulesMain': (activityDate) => `
        <h3>Activity Time: <span>${ activityDate || '-' }</span></h3>

        <h3>Do I Have the Qualification?</h3>
        <p>Any user who has applied a loan have the qualification, even those who failed to get the loan.</p>

        <h3>How to Get Lucky Draws?</h3>
        <ol>
            <b><li>Apply & Repay a loan</li></b>
            <ul>
                <li>Apply a loan <span style="color:#d52a20;">→</span> get 1 draw</li>
                <li>Repay 1 or more days in advance <span style="color:#d52a20;">→</span> get 2 draws</li>
                <li>Repay on time  <span style="color:#d52a20;">→</span> get 1 draw</li>
            </ul>

            <b><li>Inviting Friends</li></b>
            <ul><li>friends filled in info <span style="color:#d52a20;">→</span> get 2 draws</li></ul>
        </ol>

        <h3>Effective Period of the Draw&Coupon:</h3>
        <ol>
            <li>The draw is only valid within the day you get it</li>
            <li>The coupon is valid during the whole activity period</li>
        </ol>
        
        <h3>When will I Get the Gift?</h3>
        <ol>
            <li>The coupon will be sent to your account within 24 hours;</li>
            <li>If you win the physical prize or airtime, please contact our customer service to cash the prize. Thank you for your support!</li>
        </ol>

        <h3>Statement</h3>
        <p>The accoding ID number/mobile phone/identity card number are all considered to be the same user. </p>
        <p>If the user / merchant violates the rules (such as false transaction, cheating, malicious cash withdrawal, etc.), we have the right to limit the user account, cancel the illegal transaction and obtain the prize;</p>
        <p>This large turntable rules and prize configuration change with the operation adjustment, the specific page display shall prevail;</p>
    `
}